import { render, staticRenderFns } from "./GerarDimobDialog.vue?vue&type=template&id=c8d7fec6&"
import script from "./GerarDimobDialog.vue?vue&type=script&lang=js&"
export * from "./GerarDimobDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports